/* eslint-disable */
import React, { Children, cloneElement, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css, cx } from 'emotion';

const flexStyle = css`
  @media (min-width: 768px) {
    display: flex;
    justify-content: space-between;
  }
`;

const collapseStyle = css`
  display: flex;

  @media (max-width: 767px) {
    flex-direction: column-reverse;
  }
`;

const StyledSection = styled('section')`
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
  padding: 40px 32px;

  @media (min-width: 769px) {
    padding: 40px 64px;
  }

  @media (max-width: 320px) {
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 64px;
  }

  h1 {
    font-weight: 500;
    color: ${({ theme }) => theme.secondary.base};
  }
  h2 {
    font-size: 18px;
    font-weight: 300;
    color: ${({ theme }) => theme.text.dark};
  }
  h3 {
    font-family: ${({ theme }) => theme.fonts.soehneBuch};
  }

  p {
    font-size: 14px;
    font-family: ${({ theme }) => theme.fonts.soehneBuch};
    font-weight: 300;
  }
`;

const Content = ({ children, className, isSideBarLeftAlign }) => {
  let collapseToBottom = false;
  let bodyOnly = false;
  let components = {
    body: null,
    sidebar: null,
    title: null,
  };

  Children.forEach(children, (child) => {
    if (child === null) return;
    switch (child.type.displayName) {
      case 'ContentBody':
        components.body = child;
        break;
      case 'Sidebar':
        components.sidebar = child;
        collapseToBottom = child.props.collapseToBottom;
        break;
      case 'TitleBar':
        components.title = child;
        break;
      default:
        break;
    }
  });

  if (!components.title && !components.sidebar) bodyOnly = true;

  return (
    <StyledSection
      className={cx(
        components.sidebar && !components.title ? (collapseToBottom ? collapseStyle : flexStyle) : '',
        className
      )}
    >
      {components.title}
      {components.sidebar ? (
        components.title ? (
          <div className={collapseToBottom ? collapseStyle : flexStyle}>
            {!isSideBarLeftAlign && cloneElement(components.body, { sidebar: true })}
            {components.sidebar}
            {isSideBarLeftAlign && cloneElement(components.body, { sidebar: true })}
          </div>
        ) : (
          <Fragment>
            {!isSideBarLeftAlign && cloneElement(components.body, { sidebar: true })}
            {components.sidebar}
            {isSideBarLeftAlign && cloneElement(components.body, { sidebar: true })}
          </Fragment>
        )
      ) : bodyOnly ? (
        components.body.props.children
      ) : (
        components.body
      )}
    </StyledSection>
  );
};

Content.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isSideBarLeftAlign: PropTypes.bool,
};

export default Content;
